import React from "react";

import Price from "components/Tvendo/Article/DataMaster/Price/Price";

export default function () {
  return <Price />;
}
